"use client";
import React from "react";
import Image from "next/image";
import contactFormBanner from "public/contactForm/contactForm.svg";
import { NAVIGATION_LIST /*TERMS_AND_CONDITIONS*/ } from "./components/constants";
import {
  Heading,
  Text,
  Box,
  // UnorderedList,
  // ListItem,
  Button,
  Link,
  Flex,
  Stack,
  VStack,
} from "@chakra-ui/react";
import JoinMailingForm from "./components/joinMailingForm";

const SalePage = () => {
  return (
    <Stack>
      <VStack padding={8} spacing={3}>
        <Heading fontSize={"2xl"} fontWeight={"600"} textAlign="center">
          View Our Current Deals and Offers:
        </Heading>
        <Text color={"gray.700"} textAlign="center">
          As part of our mission to democratize labs, we’re always looking for an excuse
          to give you more bang for your buck 😉 Take a look at our current promotions.
        </Text>
        <Text fontSize={"xl"} margin={"1rem 0 0 0"} textAlign={"center"}>
          Currently, we do not have any ongoing sales at the moment.
        </Text>
        {/* <Box w={{base: "full", sm: "400px", md: "600px", lg: "800px"}}>
          <Image alt="Christmas 2024 Sale" src={ChristmasSale} style={{width: "100%"}} />
        </Box> */}
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={4}
          w={"100%"}
          margin={"1rem 0 0 0"}
          flexWrap={"wrap"}
        >
          {NAVIGATION_LIST.map((item) => {
            const { label, path } = item;
            return (
              <Button
                as={Link}
                href={path}
                key={path}
                textDecoration={"none"}
                padding={"7px 15px"}
                background={"blue.400"}
                border={"1px solid #4299E1"}
                color={"white"}
                size={"md"}
                _hover={{
                  background: "white",
                  color: "blue.400",
                  border: "1px solid #4299E1",
                  textDecoration: "none",
                }}
              >
                {label}
              </Button>
            );
          })}
        </Box>
      </VStack>

      {/* <Box padding={"0 1.75rem"}>
        <Heading fontSize={"2xl"} fontWeight={"600"}>
          Terms & Conditions:
        </Heading>
        <UnorderedList color={"gray.700"} margin={"0 0 0 1.25rem"}>
          {TERMS_AND_CONDITIONS.map((item, idx) => {
            return <ListItem key={idx}>{item}</ListItem>;
          })}
        </UnorderedList>
      </Box> */}
      <Box padding={"0 1.75rem"} my={10}>
        <Heading fontSize={"2xl"} fontWeight={"600"} textAlign={"center"}>
          Subscribe To Our Newsletter:
        </Heading>
        <Flex justifyContent={"center"} alignItems={"center"} direction={"column"}>
          <Image
            src={contactFormBanner}
            alt="Contact Banner"
            title={"Contact Banner"}
            blurDataURL={
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
            }
            placeholder="blur"
            width={300}
          />
          <JoinMailingForm />
        </Flex>
      </Box>
    </Stack>
  );
};

export default SalePage;
